module.exports = __webpack_public_path__ + "img/FixIT_Online_logo_hvit.5c628cd1.svg";